/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import {
    CashRegisterModelsListDto,
    CashRegistersModelsListFilterParams,
} from '../api/cashRegisterModels/cashRegisterModelsClient.typings';
import { PageQueryParams, SortQueryParams } from '../api/apiCommon.typings';
import { createAction } from '../../utils/redux-utils';
import { Notification, NOTIFICATION_TYPES } from '../../utils/utils';
import { i18n } from '../translation/i18n';

export enum CashRegisterModelsActionType {
    OPEN_REGISTRY_CASH_REGISTER_MODELS_LIST_PAGE = 'RegistryCashRegisterModelsList/ open page',
    EXIT_REGISTRY_CASH_REGISTER_MODELS_LIST_PAGE = 'RegistryCashRegisterModelsList/ exit page',

    APPLY_PAGING = 'RegistryCashRegisterModelsList/ apply paging',
    APPLY_FILTERS = 'RegistryCashRegisterModelsList/ apply filters',
    APPLY_SORTING = 'RegistryCashRegisterModelsList/ apply sorting',

    CHANGE_FILTERS = 'RegistryCashRegisterModelsList/ change filters',

    DOWNLOAD_EXCEL = 'RegistryCashRegisterModelsList/ download cash register models list as excel',
    DOWNLOAD_EXCEL_SUCCESS = 'RegistryCashRegisterModelsList/ download cash register models list as excel success',
    DOWNLOAD_EXCEL_ERROR = 'RegistryCashRegisterModelsList/ download cash register models list as excel error',

    FETCH_CASH_REGISTER_MODELS_LIST_SUCCESS = 'RegistryCashRegisterModelsList/ fetch cash register models list success',
    FETCH_CASH_REGISTER_MODELS_LIST_ERROR = 'RegistryCashRegisterModelsList/ fetch cash register models list error',
}

export const openRegistryCashRegisterModelsListAction = () =>
    createAction(CashRegisterModelsActionType.OPEN_REGISTRY_CASH_REGISTER_MODELS_LIST_PAGE);

export const exitRegistryCashRegisterModelsListAction = () =>
    createAction(CashRegisterModelsActionType.EXIT_REGISTRY_CASH_REGISTER_MODELS_LIST_PAGE);

export const applyPagingAction = (params: PageQueryParams) =>
    createAction(CashRegisterModelsActionType.APPLY_PAGING, params);

export const applyFilteringAction = () => createAction(CashRegisterModelsActionType.APPLY_FILTERS);

export const applySortingAction = (params: SortQueryParams) =>
    createAction(CashRegisterModelsActionType.APPLY_SORTING, params);

export const changeFiltersAction = (params: CashRegistersModelsListFilterParams) =>
    createAction(CashRegisterModelsActionType.CHANGE_FILTERS, params);

export const downloadCashRegisterModelsListAsExcelAction = () =>
    createAction(CashRegisterModelsActionType.DOWNLOAD_EXCEL);

export const downloadCashRegisterModelsListAsExcelSuccessAction = () =>
    createAction(CashRegisterModelsActionType.DOWNLOAD_EXCEL_SUCCESS);

export const downloadCashRegisterModelsListAsExcelErrorAction = (notification: Notification) =>
    createAction(CashRegisterModelsActionType.DOWNLOAD_EXCEL_ERROR, { notification });

export const fetchCashRegisterModelsListSuccessAction = (list: CashRegisterModelsListDto) =>
    createAction(CashRegisterModelsActionType.FETCH_CASH_REGISTER_MODELS_LIST_SUCCESS, {
        list,
        notification:
            list.count === 0
                ? {
                      type: NOTIFICATION_TYPES[1],
                      message: i18n.t('errors.notFoundByParams'),
                  }
                : null,
    });

export const fetchCashRegisterModelsListErrorAction = (notification: Notification) =>
    createAction(CashRegisterModelsActionType.FETCH_CASH_REGISTER_MODELS_LIST_ERROR, { notification });

export type CashRegisterModelsAction =
    | ReturnType<typeof openRegistryCashRegisterModelsListAction>
    | ReturnType<typeof exitRegistryCashRegisterModelsListAction>
    | ReturnType<typeof applyPagingAction>
    | ReturnType<typeof applyFilteringAction>
    | ReturnType<typeof applySortingAction>
    | ReturnType<typeof changeFiltersAction>
    | ReturnType<typeof downloadCashRegisterModelsListAsExcelAction>
    | ReturnType<typeof downloadCashRegisterModelsListAsExcelSuccessAction>
    | ReturnType<typeof downloadCashRegisterModelsListAsExcelErrorAction>
    | ReturnType<typeof fetchCashRegisterModelsListSuccessAction>
    | ReturnType<typeof fetchCashRegisterModelsListErrorAction>;
